var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"pb-3"},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")]),_c('vs-input',{staticClass:"w-full",attrs:{"disabled":_vm.disabled,"placeholder":"Ingrese el texto"},model:{value:(_vm.answerSend),callback:function ($$v) {_vm.answerSend=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"answerSend"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }